import PropTypes from "prop-types";
import { DetailedMealPlanner } from "./DetailedMealPlanner";
import { SimplifiedMealPlanner } from "./SimplifiedMealPlanner";

/**
 * MealPlannerContainer
 *
 * Wrapper component that decides which meal planner to render
 * based on the planMode (detailed vs simplified).
 */
export const MealPlannerContainer = ({ locals, api }) => {
  const { mealPlan } = locals;
  const planMode = mealPlan?.planMode || "detailed"; // default to detailed for backwards compatibility

  // Detailed meal plans: use weeks structure
  if (planMode === "detailed") {
    return <DetailedMealPlanner locals={locals} planMode={planMode} api={api} />;
  }

  // Simplified meal plans: use options structure
  if (planMode === "simplified") {
    return <SimplifiedMealPlanner locals={locals} planMode={planMode} api={api} />;
  }

  // Fallback for unknown planMode
  return <DetailedMealPlanner locals={locals} planMode={planMode} api={api} />;
};

MealPlannerContainer.propTypes = {
  locals: PropTypes.object,
};
